<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">VIP Club</h2>
            <div class="row mt-5">
                <h5 class="mt-3">
                    به باشگاه VIP ما بپیوندید و تجربه‌ای منحصر به‌فرد را تجربه کنید!
                    <br>
                    <br>
                    <br>
                    NABACO VIP CLUB فرصتی استثنایی برای مشتریان ویژه‌ای است که به دنبال خدمات متمایز، دسترسی انحصاری و تجربه‌ای ممتاز هستند. اعضای VIP Club از امکانات و مزایای اختصاصی بهره‌مند می‌شوند که تنها برای این گروه طراحی شده‌اند. اگر به دنبال بهره‌گیری از بهترین امکانات و خدمات ما هستید، باشگاه VIP ما بهترین گزینه برای شماست.                    <br>
                    <br>
                    <br>
                    <br>
                    با پیوستن به VIP Club ما، وارد دنیای انحصاری خدمات و امکانات برتر شوید. همین حالا درخواست عضویت خود را ثبت کنید و تفاوت را تجربه کنید.
                    <br>
                    <br>
                    <button class="btn-gold my-2">
                      <a href="../sign-up" style="color: black; text-decoration: none;">ثبت نام</a>
                    </button>
                </h5>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>